import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

// This one is done
const InfoWeCollect = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Information We Collect</h3>

      {/* Personal and Account Information Section */}

      <h4>Personal and Account Information</h4>

      <p>
        We may collect personal information that you provide when you create an
        account, register a company, use our services, make a purchase, contact
        us, or otherwise interact with the platform. This may include:
      </p>

      <ul>
        <li>
          Your first and last name, email address, phone number, billing
          address, and company or organization.
        </li>
        <li>
          Account and profile information associated with your individual,
          employee, company manager, or other authorized user account.
        </li>
        <li>
          Information provided by a company or company manager when creating or
          managing employee accounts and assigning training.
        </li>
        <li>
          Information you provide when contacting us about training, safety
          products, custom documentation, technical support, or other services.
        </li>
        <li>
          Your email address and communication preferences when you subscribe to
          newsletters or other promotional communications.
        </li>
      </ul>

      {/* Training Information Section */}

      <h4>Training and Course Information</h4>

      <p>
        When you participate in training through our platform, we may collect
        and maintain information relating to your training activity and records,
        including:
      </p>

      <ul>
        <li>Courses purchased, assigned, started, or completed.</li>
        <li>Course progress and completion status.</li>
        <li>Quiz and assessment responses, results, and scores.</li>
        <li>
          Training completion dates and other information required to maintain
          your training history.
        </li>
        <li>
          Certificate information and certificates generated following
          successful course completion.
        </li>
        <li>
          Information relating to training expiration dates or renewal
          requirements, where applicable.
        </li>
      </ul>

      {/* Company Information Section */}

      <h4>Company and Employee Information</h4>

      <p>
        Where training or services are provided through a company or
        organization, we may collect and maintain information necessary to
        administer that organization&apos;s account and training activities.
        This may include:
      </p>

      <ul>
        <li>Company or organization information.</li>
        <li>
          Information about employees or other individuals added to a company
          account.
        </li>
        <li>Courses purchased or assigned to those individuals.</li>
        <li>
          Training progress, completion status, results, and certificate
          information associated with company-assigned training.
        </li>
        <li>
          Information required to manage account permissions and authorized
          access to company resources.
        </li>
      </ul>

      {/* Digital Safety Forms and Documentation Section */}

      <h4>Digital Safety Forms and Documentation</h4>

      <p>
        When digital safety forms, safety manuals, or other workplace
        documentation are accessed or used through our platform, we may collect
        and store information associated with those services, including:
      </p>

      <ul>
        <li>
          Information entered into and submitted through digital safety forms.
        </li>
        <li>
          Completed form entries and information associated with those entries.
        </li>
        <li>
          Information relating to the user, company, or organization associated
          with a form or entry, where applicable.
        </li>
        <li>
          Information required to provide authorized access to safety forms,
          manuals, and other workplace documentation.
        </li>
      </ul>

      <p>
        The type of information contained in a digital safety form may vary
        depending on the form and the information entered by the user or
        organization using the service.
      </p>

      {/* Purchase and Payment Information Section */}

      <h4>Purchase and Payment Information</h4>

      <p>
        When you make or attempt to make a purchase through our platform, we may
        collect information associated with the transaction, including:
      </p>

      <ul>
        <li>Your name and contact information.</li>
        <li>Your billing information.</li>
        <li>
          Information about the courses, subscriptions, or services purchased.
        </li>
        <li>
          Transaction, payment status, purchase, and order information
          associated with the payment.
        </li>
        <li>
          Where a company purchases training, information about the users to
          whom purchased training is assigned.
        </li>
      </ul>

      <p>
        Payments are processed through Stripe or other authorized third-party
        payment processors. Payment card information is provided directly to the
        applicable payment processor and is handled in accordance with that
        provider&apos;s privacy and security practices. We may receive limited
        transaction information from the payment processor as necessary to
        confirm and manage purchases.
      </p>

      {/* Device and Usage Information Section */}

      <h4>Device and Usage Information</h4>

      <p>
        When you access our website or platform, certain technical information
        may be collected automatically. Depending on the services and
        technologies in use, this may include:
      </p>

      <ul>
        <li>
          Your IP address, browser type, device information, and time zone.
        </li>
        <li>
          Information about pages you visit and how you interact with our
          website or platform.
        </li>
        <li>
          Referring websites, links, or search terms that directed you to our
          website.
        </li>
        <li>
          Log and diagnostic information used to operate, secure, troubleshoot,
          and maintain the platform.
        </li>
      </ul>

      <p>
        We may use technologies such as cookies and log files to support website
        and platform functionality, understand usage, maintain security, and
        improve our services.
      </p>

      <ul>
        <li>
          <strong>Cookies:</strong> Small data files that may be stored on your
          device to support website functionality and other permitted purposes.
          Your browser may provide controls for managing or disabling cookies.
        </li>
        <li>
          <strong>Log Files:</strong> Technical records that may contain
          information such as IP addresses, browser information, access times,
          requested pages, errors, and other activity associated with use of the
          website or platform.
        </li>
      </ul>
    </PrivacyPolicyContainer>
  );
};

export default InfoWeCollect;
